// Community Learning Data
// Structured for Supabase migration with multi-language support
// Based on the reference image showing Community Learning features

export const communityLearningData = {
  // Page Overview
  overview: {
    id: "community_learning",
    title: {
      tc: "社群學習",
      sc: "社群学习",
      en: "Community Learning"
    },
    subtitle: {
      tc: "與其他學習者一起成長",
      sc: "与其他学习者一起成长",
      en: "Grow together with other learners"
    }
  },

  // Community Statistics Section
  statistics: {
    id: "community_stats",
    title: {
      tc: "社群概況",
      sc: "社群概况",
      en: "Community Overview"
    },
    stats: [
      {
        id: "friends_count",
        value: 127,
        label: {
          tc: "好友",
          sc: "好友",
          en: "Friends"
        },
        icon: "👥",
        color: "blue"
      },
      {
        id: "groups_count",
        value: 45,
        label: {
          tc: "群組",
          sc: "群组",
          en: "Groups"
        },
        icon: "🏘️",
        color: "green"
      },
      {
        id: "interactions_count",
        value: 892,
        label: {
          tc: "互動次數",
          sc: "互动次数",
          en: "Interactions"
        },
        icon: "💬",
        color: "purple"
      }
    ]
  },

  // Main Action Buttons Section
  mainActions: {
    id: "main_actions",
    title: {
      tc: "主要功能",
      sc: "主要功能",
      en: "Main Features"
    },
    actions: [
      {
        id: "find_learning_partner",
        icon: "👥",
        title: {
          tc: "尋找學習夥伴",
          sc: "寻找学习伙伴",
          en: "Find Learning Partner"
        },
        description: {
          tc: "找到適合的學習夥伴一起練習",
          sc: "找到适合的学习伙伴一起练习",
          en: "Find suitable learning partners to practice together"
        },
        gradient: "from-blue-400 to-blue-600",
        action: "find_partner"
      },
      {
        id: "join_group_chat",
        icon: "💬",
        title: {
          tc: "加入群組對話",
          sc: "加入群组对话",
          en: "Join Group Chat"
        },
        description: {
          tc: "參與群組討論和學習交流",
          sc: "参与群组讨论和学习交流",
          en: "Participate in group discussions and learning exchanges"
        },
        gradient: "from-pink-400 to-purple-600",
        action: "join_chat"
      }
    ]
  },

  // Community Feed Section
  communityFeed: {
    id: "community_feed",
    title: {
      tc: "社群動態",
      sc: "社群动态",
      en: "Community Feed"
    },
    posts: [
      {
        id: "post_1",
        userId: "emily_wang",
        userName: {
          tc: "Emily Wang",
          sc: "Emily Wang",
          en: "Emily Wang"
        },
        userAvatar: "👤",
        timestamp: {
          tc: "2小時前",
          sc: "2小时前",
          en: "2 hours ago"
        },
        content: {
          tc: "今天完成了商務英語課程!感覺自信多了💪",
          sc: "今天完成了商务英语课程!感觉自信多了💪",
          en: "Completed business English course today! Feeling much more confident 💪"
        },
        likes: 23,
        comments: 5,
        shares: 2,
        isLiked: false,
        isShared: false
      },
      {
        id: "post_2",
        userId: "michael_chen",
        userName: {
          tc: "Michael Chen",
          sc: "Michael Chen",
          en: "Michael Chen"
        },
        userAvatar: "👤",
        timestamp: {
          tc: "4小時前",
          sc: "4小时前",
          en: "4 hours ago"
        },
        content: {
          tc: "分享我的發音練習心得:多聽多模仿是關鍵!",
          sc: "分享我的发音练习心得:多听多模仿是关键!",
          en: "Sharing my pronunciation practice tips: listening and imitating are key!"
        },
        likes: 45,
        comments: 12,
        shares: 8,
        isLiked: true,
        isShared: false
      },
      {
        id: "post_3",
        userId: "sarah_liu",
        userName: {
          tc: "Sarah Liu",
          sc: "Sarah Liu",
          en: "Sarah Liu"
        },
        userAvatar: "👤",
        timestamp: {
          tc: "6小時前",
          sc: "6小时前",
          en: "6 hours ago"
        },
        content: {
          tc: "尋找口語練習夥伴,有興趣的朋友請聯繫我!",
          sc: "寻找口语练习伙伴,有兴趣的朋友请联系我!",
          en: "Looking for a speaking practice partner, interested friends please contact me!"
        },
        likes: 18,
        comments: 8,
        shares: 3,
        isLiked: false,
        isShared: false
      }
    ]
  },

  // Language Exchange Section
  languageExchange: {
    id: "language_exchange",
    title: {
      tc: "語言交換",
      sc: "语言交换",
      en: "Language Exchange"
    },
    card: {
      id: "language_exchange_card",
      title: {
        tc: "尋找語言交換夥伴",
        sc: "寻找语言交换伙伴",
        en: "Find Language Exchange Partner"
      },
      description: {
        tc: "與母語人士進行一對一練習",
        sc: "与母语人士进行一对一练习",
        en: "Practice one-on-one with native speakers"
      },
      buttonText: {
        tc: "開始配對",
        sc: "开始配对",
        en: "Start Matching"
      },
      icon: "🌍",
      gradient: "from-green-400 to-blue-600",
      action: "start_matching"
    }
  },

  // Navigation and UI Elements
  navigation: {
    backButton: {
      tc: "返回",
      sc: "返回",
      en: "Back"
    },
    likeButton: {
      tc: "讚",
      sc: "赞",
      en: "Like"
    },
    commentButton: {
      tc: "評論",
      sc: "评论",
      en: "Comment"
    },
    shareButton: {
      tc: "分享",
      sc: "分享",
      en: "Share"
    }
  },

  // Status Messages
  statusMessages: {
    loading: {
      tc: "載入中...",
      sc: "加载中...",
      en: "Loading..."
    },
    noPosts: {
      tc: "暫無動態",
      sc: "暂无动态",
      en: "No posts yet"
    },
    errorLoading: {
      tc: "載入失敗",
      sc: "加载失败",
      en: "Failed to load"
    }
  },

  // Interaction Tracking
  interactions: {
    likePost: {
      tc: "已讚",
      sc: "已赞",
      en: "Liked"
    },
    unlikePost: {
      tc: "取消讚",
      sc: "取消赞",
      en: "Unlike"
    },
    sharePost: {
      tc: "已分享",
      sc: "已分享",
      en: "Shared"
    },
    commentAdded: {
      tc: "評論已添加",
      sc: "评论已添加",
      en: "Comment added"
    }
  }
};

// Helper functions for community learning management
export const getPostById = (postId) => {
  return communityLearningData.communityFeed.posts.find(post => post.id === postId);
};

export const getUserById = (userId) => {
  // Mock user data - in real app this would come from user database
  const users = {
    emily_wang: {
      id: "emily_wang",
      name: { tc: "Emily Wang", sc: "Emily Wang", en: "Emily Wang" },
      avatar: "👤",
      level: "intermediate",
      joinDate: "2024-01-15"
    },
    michael_chen: {
      id: "michael_chen",
      name: { tc: "Michael Chen", sc: "Michael Chen", en: "Michael Chen" },
      avatar: "👤",
      level: "advanced",
      joinDate: "2023-11-20"
    },
    sarah_liu: {
      id: "sarah_liu",
      name: { tc: "Sarah Liu", sc: "Sarah Liu", en: "Sarah Liu" },
      avatar: "👤",
      level: "beginner",
      joinDate: "2024-02-01"
    }
  };
  return users[userId];
};

export const getStatById = (statId) => {
  return communityLearningData.statistics.stats.find(stat => stat.id === statId);
};

export const getActionById = (actionId) => {
  return communityLearningData.mainActions.actions.find(action => action.id === actionId);
};

export const togglePostLike = (postId) => {
  const post = getPostById(postId);
  if (post) {
    post.isLiked = !post.isLiked;
    post.likes += post.isLiked ? 1 : -1;
  }
  return post;
};

export const togglePostShare = (postId) => {
  const post = getPostById(postId);
  if (post) {
    post.isShared = !post.isShared;
    post.shares += post.isShared ? 1 : -1;
  }
  return post;
};

export const addComment = (postId, commentText) => {
  const post = getPostById(postId);
  if (post) {
    post.comments += 1;
    // In real app, this would add the comment to a comments array
    console.log(`Comment added to post ${postId}: ${commentText}`);
  }
  return post;
};

export const findLearningPartner = (criteria) => {
  // Mock partner matching logic
  console.log('Finding learning partner with criteria:', criteria);
  return {
    success: true,
    partner: {
      id: "partner_123",
      name: { tc: "Alex Johnson", sc: "Alex Johnson", en: "Alex Johnson" },
      level: "intermediate",
      interests: ["business_english", "conversation"],
      availability: "weekends"
    }
  };
};

export const joinGroupChat = (groupId) => {
  // Mock group chat joining logic
  console.log('Joining group chat:', groupId);
  return {
    success: true,
    groupId: groupId,
    message: "Successfully joined group chat"
  };
};

export const startLanguageMatching = (preferences) => {
  // Mock language exchange matching logic
  console.log('Starting language matching with preferences:', preferences);
  return {
    success: true,
    matchId: "match_456",
    partner: {
      id: "native_speaker_789",
      name: { tc: "Maria Garcia", sc: "Maria Garcia", en: "Maria Garcia" },
      nativeLanguage: "English",
      learningLanguage: "Chinese",
      level: "intermediate"
    }
  };
};

export const getCommunityStats = () => {
  return communityLearningData.statistics.stats;
};

export const getRecentPosts = (limit = 10) => {
  return communityLearningData.communityFeed.posts.slice(0, limit);
};

export const createPost = (userId, content) => {
  const newPost = {
    id: `post_${Date.now()}`,
    userId: userId,
    userName: getUserById(userId)?.name || { tc: "User", sc: "User", en: "User" },
    userAvatar: "👤",
    timestamp: { tc: "剛剛", sc: "刚刚", en: "Just now" },
    content: content,
    likes: 0,
    comments: 0,
    shares: 0,
    isLiked: false,
    isShared: false
  };
  
  // In real app, this would add to database
  communityLearningData.communityFeed.posts.unshift(newPost);
  return newPost;
};
